import { apiRequest } from './httpRequest';
import type { ChemMoleculeV1Document } from '@peruselab/structure-editor/domain/moleculeProjection';
import type { Provenance } from '@peruselab/contracts';

export interface PartialChargeComputation {
  readonly charges: Readonly<Record<string, number>>;
  readonly provenance: Provenance;
}

// On-demand only -- unlike aromaticity/CIP perception (client-side RDKit, debounced), the bundled
// RDKit-JS build has no partial-charge API, so this is computed server-side via CDK instead. See
// PartialChargeController (#144's follow-on chemistry-fidelity work).
export async function computePartialCharges(molecule: ChemMoleculeV1Document): Promise<PartialChargeComputation> {
  return apiRequest<PartialChargeComputation>('/chemistry/partial-charges', 'partial charge', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(molecule)
  });
}
